<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogVisible" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="120px">
            <el-form-item :label="$t('pgCommon.NAME')" prop="sName">
                <td-input v-model="formInfo.sName" maxlength="200"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.TIME_TASK')" prop="sTaskId">
                <td-select v-model="formInfo.sTaskId" url="/timedTaskManager/findJob" keys="jobKey" text="jobName" urlParam="" requestType="POST"></td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATASOURCE')" prop="sDataSourceId">
                <td-select v-model="formInfo.sDataSourceId" url="/setting/databaseController/queryDbInfo" keys="id" text="caption" urlParam="" requestType="POST"></td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.SQL_PARAM_TYPE')" prop="iSqlParamType">
                <td-select v-model="formInfo.iSqlParamType" :options="sqlParamTypes" keys="id" text="name"></td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.SQL_CONTENT')" prop="sSql">
                <td-input v-model="formInfo.sSql" type="textarea" maxlength="5000" @change="sqlChange()"></td-input>
                <td-button @click="checkSql">{{ $t('pgCommon.SQL_TEST') }}</td-button>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.OUTPUT_TYPE')" prop="iOutput">
                <td-select v-model="formInfo.iOutput" :options="outputTypes" keys="id" text="name" @change="outPutChange"></td-select>
            </el-form-item>
            <component :is="outputName" :params="formInfo.sParam" :output="formInfo.iOutput" ref="outputComponent"></component>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>

<script>
import api from '../assets/api.js';
import outputComponents from "./outputComponents.js"
export default {
    // 初始化渲染
    components: {},
    props: {
        title: {},
        dialogVisible: {},
        editItem: {
            type: Object
        },
        outputTypes: { type: Array },
        sqlParamTypes: { type: Array }
    },
    created() {
        if (this.editItem.sId) {
            this.initEditData();
        }
    },
    mounted() {},
    // 定义变量
    data() {
        return {
            // 短信模板表单信息
            formInfo: {},
            output: 'db_task_output_',
            outputName: 'db_task_output_0',
            saveLoading: false,
            sqlTest: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_TEMPLATE_CAPTION_IS_NULL'),
                        trigger: 'blur'
                    },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sTaskId: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_TASK_ID')
                    }
                ],
                sDataSourceId: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_DATASOURCE')
                    }
                ],
                iSqlParamType: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_DATASOURCE')
                    }
                ],
                sSql: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SQL_CONTENT')
                    }
                ],
                iOutput: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_OUTPUT')
                    }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sId = this.editItem.sId;
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.sTaskId = this.editItem.sTaskId;
            this.formInfo.sDataSourceId = this.editItem.sDataSourceId;
            this.formInfo.iSqlParamType = this.editItem.iSqlParamType;
            this.formInfo.sSql = this.editItem.sSql;
            this.formInfo.iOutput = this.editItem.iOutput;
            this.formInfo.sParam = this.editItem.sParam;
            this.outputName = this.output + this.formInfo.iOutput;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$refs.outputComponent.$refs['formInfo'].validate(validRule => {
                        if (validRule) {
                            this.saveLoading = true;
                            this.formInfo.sParam = this.$refs.outputComponent.getFromInfo();
                            api.addDbTask(this.formInfo, response => {
                                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.statusMessage,
                                        type: 'error'
                                    });
                                    this.$log.error('/dbTask/save', response.data.statusMessage);
                                    this.saveLoading = false;
                                    return;
                                }
                                this.saveLoading = false;
                                let message = this.$t('common.ADD_SUCCESS');
                                if (this.formInfo.sId) {
                                    message = this.$t('common.MODIFY_SUCCESS');
                                }
                                this.$message({ showClose: true, message: message, type: 'success' });
                                this.SmsDialogClose();
                            });
                        }
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.$emit('SmsDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
            this.formInfo = {};
        },
        // 关闭窗口之前需要调用的方法
        SmsDialogClose() {
            this.cancel();
            this.$emit('submit');
        },
        checkSql() {
            if (!this.formInfo.sDataSourceId) {
                this.$message({
                    showClose: true,
                    message: this.$t('pgError.ERROR_SELECT_DATASOURCE'),
                    type: 'error'
                });
                return;
            }
            if (!this.formInfo.sSql) {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_SQL_CONTENT'), type: 'error' });
                return;
            }
            api.testSQL(this.formInfo, response => {
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: this.$t('pgError.ERROR_SQL_TEST_FAIL'), type: 'error' });
                    this.sqlTest = false;
                    return;
                }
                this.sqlTest = true;
                this.$message({ showClose: true, message: this.$t('pgCommon.SQL_TEST_SUCCESS'), type: 'success' });
            });
        },
        outPutChange() {
            this.outputName = this.output + this.formInfo.iOutput;
        },
        sqlChange() {
            this.sqlTest = false;
        }
    }
};
</script>

<style scoped></style>
